import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { PaymentMethodCode } from '../../../shared/enums/payment-method-code';
import { Guid } from '@web/utils';
import { PublicPaymentMethodPropertyResponse } from './public-payment-method-property.response';

@jsonObject
export class PublicCheckoutOrderPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonArrayMember(PublicPaymentMethodPropertyResponse)
  public readonly properties!: PublicPaymentMethodPropertyResponse[];
}
